module.exports = __webpack_public_path__ + "static/media/aajubaajuImg.e5b619d6.svg";